import React from 'react';
import { connect } from 'react-redux';

import EventsTable from '../../components/ExchEventsTable/ExchEventsTable';
import ExchRaceTable from './ExchRaceTable';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { RootState } from '../../models/RootState';
import './ExchangeSportsHomeView.scss';

type StoreProps = {
  loggedIn: boolean;
  selectedEventType: SelectedObj;
};

const ExchSportsHome: React.FC<StoreProps> = (props) => {
  const { loggedIn, selectedEventType } = props;

  return (
    <>
      {!['7', '4339'].includes(selectedEventType.id) ? (
        <EventsTable loggedIn={loggedIn} />
      ) : (
        <ExchRaceTable loggedIn={loggedIn} />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    selectedEventType: state.exchangeSports.selectedEventType,
  };
};

export default connect(mapStateToProps)(ExchSportsHome);
